
import { useContext } from 'react';
import { PedidosContext } from '../../../context/PedidosContext';
import { StyledTable, PedidoVentaContainer, } from '../PedidosComponents';
import { columnasCabecera, conditionalStyles, customStyles, opcionesdepagina, } from '../tableOptions';


function Cabecera() {

  const { listado, quitarDeLista } = useContext(PedidosContext);

  return (
    <PedidoVentaContainer>
      <StyledTable
        columns={columnasCabecera(quitarDeLista)}
        data={listado}
        customStyles={customStyles}
        conditionalRowStyles={conditionalStyles}
        pagination
        paginationComponentOptions={opcionesdepagina}
        fixedHeader
        fixedHeaderScrollHeight='200px'
        dense
        highlightOnHover
        responsive={true}
        noDataComponent={<div>Seleccione productos para comenzar </div>
        }
      />
    </PedidoVentaContainer>
  );
}

export default Cabecera;
Cabecera.propTypes = {};